/** Normalizes provider phone addresses without pulling server-only crypto into the browser. */
export function normalizePhoneAddress(value) {
    const address = typeof value === 'string'
        ? value
        : (value?.number || value?.phone || value?.value || value?.phone_number || '');
    return typeof address === 'string' ? address.replace(/^whatsapp:/i, '').trim() : '';
}

export function normalizePhoneE164(value) {
    const address = normalizePhoneAddress(value);
    const digits = address.replace(/\D/g, '');
    if (!digits) return '';
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
    return `+${digits}`;
}

export function phoneAddressesMatch(first, second) {
    const normalizedFirst = normalizePhoneE164(first);
    return Boolean(normalizedFirst && normalizedFirst === normalizePhoneE164(second));
}

export function findContactByPhone(contacts, phone) {
    return (Array.isArray(contacts) ? contacts : []).find((contact) =>
        Array.isArray(contact?.phones)
        && contact.phones.some((candidate) => phoneAddressesMatch(candidate, phone))
    ) ?? null;
}
